import { Box, Container, Grid, Typography } from "@mui/material";
import { Route, Routes } from "react-router-dom";
import Farms from "views/Farms";
import LandingPage from "views/LandingPage";
import Pools from "views/Pools";
import SideBar from "views/SideBar";



const Home: React.FC = () => {
    return (
        <>
            <SideBar></SideBar>
        </>
    );
};

export default Home;
